export default Object.freeze({
  LEAD: 'Lead',
  SERVICE_REQUEST: 'Service Request',
  SERVICE_JOB: 'Service Job',
});
